import {
  Avatar,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import React from "react"
import classNames from "classnames"
import Carousel from "react-slick"
import navRight from "../../images/banner-nav-right.svg"
import navLeft from "../../images/banner-nav-left.svg"
import arrowDown from "../../images/ourstoryAssets/Influential/chevron-down.svg"
import arrowRight from "../../images/ourstoryAssets/Influential/right-chevron.svg"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"
import _ from "lodash"

// import mobBanner from "../../images/ourstoryAssets/Banner/Mobile.png"
// import webBanner from "../../images/ourstoryAssets/Banner/Web.png"
// import firstImgHW from "../../images/ourstoryAssets/TheHowAndWhat/Img1.png"
// import secondImgHW from "../../images/ourstoryAssets/TheHowAndWhat/Img2.png"
// import thirdImgHW from "../../images/ourstoryAssets/TheHowAndWhat/Img3.png"
// import mobSolution from "../../images/ourstoryAssets/Influential/Mobile.png"
// import webSolution from "../../images/ourstoryAssets/Influential/Web.png"

const useStyles = makeStyles(theme => ({
  introHead: {
    padding: "4rem 6rem 0rem 6rem",
    [theme.breakpoints.down(330)]: {
      padding: "3rem 3rem 0rem 3rem",
    },
    "& .MuiTypography-root": {
      fontSize: "24px",
      fontFamily: "'Poppins', sans-serif",
      "&:first-child": {
        color: "#686868",
      },
      "&:last-child": {
        color: "#eea01e",
        fontWeight: 600,
      },
    },
    [theme.breakpoints.up("md")]: {
      padding: "8rem 3rem 0rem 3rem",
    },
  },
  introImage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bannerImage: {
    // content: `url(${mobBanner})`,
    margin: 0,
    padding: "5rem 1rem 2.5rem 1rem",
    // [theme.breakpoints.up("md")]: {
    //   content: `url(${webBanner})`,
    // },
  },
  scrollContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",

    "& .MuiTypography-root": {
      fontSize: "16px",
      opacity: 0.25,
      animation: `$pulse 2s linear alternate infinite`,
      paddingBottom: "8px",
    },
  },
  chevron: {
    position: "absolute",
    width: "14px",
    height: "3px",
    opacity: 0,
    transform: "scale3d(0.5, 0.5, 0.5)",
    animation: `$move 3s ease-out infinite`,
    "&:first-child": {
      animation: `$move 3s ease-out 1s infinite`,
    },
    "&:nth-child(2)": {
      animation: `$move 3s ease-out 2s infinite`,
    },
    "&:before, &:after": {
      content: '" "',
      position: "absolute",
      top: 0,
      height: "100%",
      width: "51%",
      background: "rgb(94, 94, 94)",
    },
    "&:before": {
      left: 0,
      transform: "skew(0deg, 30deg)",
    },
    "&:after": {
      right: 0,
      width: "50%",
      transform: "skew(0deg, -30deg)",
    },
  },

  "@keyframes move": {
    "25%": {
      opacity: 1,
    },
    "33%": {
      opacity: 1,
      transform: "translateY(30px)",
    },
    "67%": {
      opacity: 1,
      transform: "translateY(40px)",
    },
    "100%": {
      opacity: 0,
      transform: "translateY(55px) scale3d(0.5, 0.5, 0.5)",
    },
  },

  "@keyframes pulse": {
    to: {
      opacity: 1,
    },
  },

  sectionHeads: {
    paddingTop: "6rem",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "3rem",
    },
    "& .MuiTypography-h5": {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 600,
      textTransform: "uppercase",
      [theme.breakpoints.up("lg")]: {
        fontSize: "2.5rem",
      },
    },
    "& .MuiTypography-body2": {
      padding: "1rem 2rem",
      opacity: 0.5,
      [theme.breakpoints.up("lg")]: {
        fontSize: "1rem",
      },
    },
  },

  pinkSection: {
    backgroundColor: "#F9BAC6",
  },
  firstCardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  firstCard: {
    margin: "3rem",
    borderRadius: "8px",
    width: "calc(100% - 30%)",
    maxHeight: "calc(100% - 20%)",
    height: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 20%)",
    },
    [theme.breakpoints.up("md")]: {
      height: "350px",
    },
    "& .MuiTypography-body2": {
      fontWeight: 400,
      fontFamily: "'Roboto'",
      opacity: 0.5,
      padding: "0px 8px",
    },
    "& .MuiCardContent-root": {
      [theme.breakpoints.up("lg")]: {
        padding: "1rem 4rem",
      },
    },
  },
  firstCardTitle: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
    padding: "0.5rem 1.5rem 2rem 1.5rem",
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.2rem",
    },
  },
  firstCardSubTitle: {
    [theme.breakpoints.up("md")]: {
      paddingTop: "2.5rem !important",
    },
  },
  hwImgContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  howWeStartedImage: {
    height: "13rem",
    margin: 0,
  },
  ulList: {
    paddingTop: "8px",
    listStyleType: "none",
    margin: 0,
  },
  blueSection: {
    backgroundColor: "#AFE7DD",
    "& .MuiGrid-container": {
      // [theme.breakpoints.up("md")]: {
      //   padding: "3rem 3rem 2rem 3rem",
      // },
    },
  },
  secondImgHW: {
    marginTop: "2rem",
    [theme.breakpoints.up("md")]: {
      margin: 0,
    },
  },
  thirdImgHW: {
    marginBottom: "2rem",
    [theme.breakpoints.up("md")]: {
      margin: 0,
    },
  },
  benefitsCard: {
    boxShadow: "none",
    height: "210px",
    [theme.breakpoints.up("md")]: {
      height: "280px",
    },
    [theme.breakpoints.up("lg")]: {
      height: "230px",
    },
    "& .MuiTypography-body2": {
      fontWeight: 400,
      fontFamily: "'Roboto'",
      opacity: 0.5,
      paddingTop: "1rem",
      [theme.breakpoints.up("md")]: {
        paddingTop: "2rem",
      },
    },
    "& .MuiCardContent-root": {
      [theme.breakpoints.down(330)]: {
        padding: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        padding: "2rem",
      },
      [theme.breakpoints.up("md")]: {
        padding: "35px",
      },
      [theme.breakpoints.up("lg")]: {
        padding: "35px 60px 35px 60px",
      },
    },
  },
  benefitsCardTitle: {
    textTransform: "uppercase",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.1rem",
    },
  },
  benefitsContent: {
    [theme.breakpoints.up("md")]: {
      paddingBottom: "4rem",
    },
    overflow: "hidden",
    "& .slick-slide": {
      "&:first-child": {
        borderRight: "1px solid lightgrey",
      },
      "&:nth-child(2)": {
        borderRight: "1px solid lightgrey",
      },
    },
  },
  swipeWrapper: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    display: "flex",
    alignItems: "center",
    padding: "0rem 2rem 4rem 2rem",
    "& span": {
      display: "block",
      width: "8px",
      margin: "auto",
      height: "5px",
      position: "absolute",
      transform: "rotate(180deg)",
      "& span": {
        background: `url(${arrowRight})`,
        display: "block",
        width: "20px",
        margin: "auto",
        right: "0px",
        height: "10px",
        opacity: 1,
        position: "absolute",
        animation: `$animate-arrow-1 1s ease-in-out infinite`,
      },
      "&:before": {
        content: '""',
        background: `url(${arrowRight})`,
        display: "block",
        width: "20px",
        margin: "auto",
        right: "10px",
        height: "10px",
        position: "absolute",
        opacity: 0.5,
        animation: `$animate-arrow-2 1s ease-in-out infinite 0.1s`,
      },
      "&:after": {
        content: '""',
        background: `url(${arrowRight})`,
        display: "block",
        width: "20px",
        margin: "auto",
        right: "20px",
        height: "10px",
        position: "absolute",
        opacity: 0.3,
        animation: `$animate-arrow-3 1s ease-in-out infinite 0.2s`,
      },
    },
    "& .MuiTypography-body2": {
      fontFamily: "'Poppins', sans-serif",
      color: "#FD433E",
    },
  },
  arrowContainer: {
    marginRight: "3rem",
  },
  "@keyframes animate-arrow-1": {
    "0%": { transform: "translateX(-40px)", opacity: 0 },
    "70%": { transform: "translateX(0px)", opacity: 1 },
    "100%": { transform: "translateX(0px)", opacity: 1 },
  },
  "@keyframes animate-arrow-2": {
    "0%": { transform: "translateX(-20px)", opacity: 0 },
    "70%": { transform: "translateX(0px)", opacity: 0.5 },
    "100%": { transform: "translateX(0px)", opacity: 0.5 },
  },
  "@keyframes animate-arrow-3": {
    "0%": { transform: "translateX(-10px)", opacity: 0 },
    "70%": { transform: "translateX(0px)", opacity: 0.3 },
    "100%": { transform: "translateX(0px)", opacity: 0.3 },
  },
  productSection: {
    backgroundColor: "#212121",
    overflow: "hidden",
  },
  productHead: {
    color: "#FFFFFF",
    padding: "2.5rem 1.4rem 0rem 1.4rem",
  },
  productCard: {
    margin: "2rem",
    borderRadius: "8px",
    backgroundColor: "#2C2C2C",
    color: "#FFFFFF",
    height: "200px",
    width: "calc(100% - 17%) !important",
    // [theme.breakpoints.up("sm")]: {
    //   height: "100%",
    // },
    [theme.breakpoints.up("sm")]: {
      height: "260px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% - 5%) !important",
    },
    "& .MuiTypography-body2": {
      fontWeight: 400,
      fontFamily: "'Roboto'",
      opacity: 0.5,
      padding: "2rem 1rem 1rem 1rem",
      [theme.breakpoints.up("lg")]: {
        padding: "2rem 3rem 1rem 1rem",
      },
    },
  },
  productCardTitle: {
    fontFamily: "'Roboto'",
    fontWeight: 500,
    display: "inline-block",
    position: "relative",
    padding: "0.6rem 1rem 8px 1rem",
  },
  productSlider: {
    "& .slick-slide": {
      paddingBottom: "2rem",
    },
    "& .next, & .prev": {
      cursor: "pointer",
      zIndex: 1,
      width: "2.5rem",
    },
    "& .next": {
      position: "absolute",
      right: "0.5rem",
      top: "40%",
    },
    "& .prev": {
      position: "absolute",
      left: "0.5rem",
      top: "40%",
    },
    "& .slick-dots": {
      bottom: "30px",
      "& .slick-active": {
        "& button": {
          "&:before": {
            color: "#FD433E",
            opacity: "unset",
            fontSize: "10px",
          },
        },
      },
      "& li": {
        "& button": {
          "&:before": {
            color: "#FFFFFF",
            fontSize: "10px",
          },
        },
      },
    },
  },
  solutionSection: {
    // backgroundImage: `url(${mobSolution})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    // [theme.breakpoints.up("sm")]: {
    //   backgroundImage: `url(${webSolution})`,
    // },
    "& .MuiTypography-subtitle1": {
      fontFamily: "'Roboto'",
      opacity: 0.7,
      padding: "0rem 4rem 2rem 2.5rem",
      lineHeight: 1.5,
      [theme.breakpoints.up("sm")]: {
        width: "60%",
      },
      [theme.breakpoints.up("md")]: {
        width: "40%",
      },
    },
  },
  solutionHead: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: "2rem",
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#FFFFFF",
    padding: "7rem 4rem 2rem 2.5rem",
    lineHeight: 1.3,
    [theme.breakpoints.up("sm")]: {
      padding: "3rem 4rem 2rem 2.5rem",
      width: "65%",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "2.5rem",
      width: "45%",
    },
  },
  arrowDown: {
    padding: "0rem 4rem 75% 2.5rem",
    [theme.breakpoints.up("sm")]: {
      padding: "0rem 4rem 1rem 2.5rem",
    },
  },
  bookingSection: {
    backgroundColor: "#212121",
    overflow: "hidden",
    "& .MuiDivider-root": {
      backgroundColor: "rgb(184 183 183)",
      margin: "3rem",
    },
  },
  solutionCardHolder: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  solutionSlider: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    "& .next, & .prev": {
      cursor: "pointer",
      zIndex: 1,
      width: "1rem",
    },
    "& .next": {
      position: "absolute",
      right: "0.5rem",
      top: "40%",
    },
    "& .prev": {
      position: "absolute",
      left: "0.5rem",
      top: "40%",
    },
    "& .slick-dots": {
      "& .slick-active": {
        "& button": {
          "&:before": {
            color: "#FD433E",
            opacity: "unset",
            fontSize: "10px",
          },
        },
      },
      "& li": {
        "& button": {
          "&:before": {
            color: "#FFFFFF",
            fontSize: "10px",
          },
        },
      },
    },
    "& .MuiSvgIcon-root": {
      color: "#afafaf",
      fontSize: "3rem",
      "&:hover": {
        color: "#FFFFFF",
      },
    },
  },
  solutionDetails: {
    padding: "2rem 3rem 0rem 3rem",
    [theme.breakpoints.up("sm")]: {
      padding: "2rem 0rem 0rem 3rem",
    },
    "& .MuiTypography-subtitle1": {
      fontFamily: "'Roboto'",
      fontWeight: "normal",
      color: "#FFFFFF",
      lineHeight: 1.3,
      padding: "1.5rem 0rem 2rem 0rem",
      position: "relative",
      display: "inline-block",
      opacity: 0.8,
    },
    "& .MuiAvatar-root": {
      backgroundColor: "#404040",
      fontFamily: "'Poppins', sans-serif",
      fontSize: "1rem",
    },
  },
  solutionCard: {
    display: "flex",
  },
  solDivider: {
    content: '" "',
    height: "3rem",
    borderRadius: "8px",
    marginLeft: "2rem",
  },
  demoSection: {
    padding: "2.5rem 1.5rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiTypography-body1": {
      fontFamily: "'Poppins', sans-serif",
      fontWeight: "600",
      color: "#FFFFFF",
      textTransform: "uppercase",
      [theme.breakpoints.up("lg")]: {
        fontSize: "1.5rem",
      },
    },
    "& .MuiTypography-subtitle1": {
      fontWeight: 400,
      fontFamily: "'Roboto'",
      opacity: 0.5,
      color: "#FFFFFF",
      lineHeight: 3.5,
    },
    "& .MuiButtonBase-root": {
      marginTop: "1rem",
      backgroundColor: "#1DAB45",
      color: "#fff",
      fontFamily: "'Poppins'",
    },
  },
}))

const sectionData = {
  benefits: [
    {
      title: "Centralizes Data",
      text:
        "Create a single point of data storage to maintain, increase the accessibility of all types of data and conduct meaningful analysis.",
      border: true,
    },
    {
      title: "Easy to Use",
      text:
        "Saving you the search time with an AI-based Enterprise solution with user-friendly interface that helps users navigate through the entire solution and accomplish tasks easily.",
      border: false,
    },
    {
      title: "3rd party integration",
      text:
        "Multiple operations are supported by multiple software, which results in data scattering. Set your process straight by integrating necessary external data.",
      border: true,
    },
    {
      title: "Import & export of data",
      text:
        "Making your life hassle-free by helping your brand load and unload an unlimited amount of data from various sources with ease.",
      border: false,
    },
    {
      title: "Improves operations",
      text:
        "Making you internally strong with end to end collaboration solution that connects every entity with your brand and standardizes the way you operate.",
      border: true,
    },
    {
      title: "All in one platform",
      text:
        "Giving you a holistic view of your entire organization by bringing together data, solutions and insights. Making it easy to gain knowledge of the overall organization performance.",
      border: false,
    },
  ],
  products: [
    {
      title: "GlassX",
      text:
        "Collaborate, organize and improve your internal operations with real time data.",
      color: "#4285F4",
    },
    {
      title: "PriceX",
      text:
        "No revenue leakage, customize offers & set competitive prices with real time analysis.",
      color: "#EA4335",
    },
    {
      title: "DiscoverX",
      text:
        "Increase customer acquisitions, strengthen brand reputation, make instant & accurate decisions.",
      color: "#FBBC05",
    },
    {
      title: "DashX",
      text:
        "Get a view of everything important at a place and make timely yet crucial decisions.",
      color: "#34A853",
    },
    // {
    //   title: "ScoopX",
    //   text:
    //     "Doesn't divert your customers to your competitors irrespective of the sales channel.",
    //   color: "#1CD8D8",
    // },
    {
      title: "CounterfeitX",
      text:
        "Protects your brand reputation by identifying & preventing unauthorized resellers and rogue retailers.",
      color: "#b031ff",
    },
    {
      title: "P-reX",
      text:
        "Enhance your customers shopping experience by analyzing their behavior.",
      color: "#d87b1c",
    },
  ],
  solutions: [
    {
      text:
        "Making Internal Collaboration strong by connecting your organization, employees and clients at a place",
      color: "#4285F4",
    },
    {
      text:
        "Removing the hassle of searching internal data and giving weight to your decision making with 360-degree search",
      color: "#EA4335",
    },
    {
      text:
        "Decide the price of a product/service easily and increase your profit margin in a dynamically changing market.",
      color: "#FBBC05",
    },
    {
      text:
        "Saving your time by helping you understand the dynamics of your entire organization in an organized pattern.",
      color: "#34A853",
    },
    {
      text:
        "Protecting your brand reputation by bringing forth digital counterfeits.",
      color: "#1CD8D8",
    },
    {
      text:
        "Bringing you insights that will help you personalize and improvise your digital presence.",
      color: "#212121",
    },
  ],
}
const OurStory = ({
  webBanner,
  mobBanner,
  firstImgHW,
  secondImgHW,
  thirdImgHW,
  webSolution,
  mobSolution,
}) => {
  const classes = useStyles()
  const [productIndex, setProductIndex] = React.useState(0)
  const [solIndex, setSolIndex] = React.useState(0)
  const [isSwipeable, SetIsSwipeable] = React.useState(true)
  const theme = useTheme()
  const upMD = useMediaQuery(theme.breakpoints.up("md"))

  const NextArrow = props => {
    const { onClick, style } = props
    style.display = onClick === null ? "none" : "block"
    return (
      <img
        src={navRight}
        className="next"
        onClick={onClick}
        style={style}
        alt="next"
      />
    )
  }
  const PrevArrow = props => {
    const { onClick } = props
    return (
      productIndex != 0 && (
        <img src={navLeft} className="prev" onClick={onClick} alt="prev" />
      )
    )
  }

  const NavigateNext = props => {
    const { onClick, style } = props
    style.display = onClick === null ? "none" : "block"
    return (
      <IconButton className="next" onClick={onClick} style={style}>
        <NavigateNextIcon />
      </IconButton>
    )
  }

  const NavigatePrevious = props => {
    const { onClick } = props
    return (
      solIndex != 0 && (
        <IconButton className="prev" onClick={onClick}>
          <NavigateBeforeIcon />
        </IconButton>
      )
    )
  }

  const SlideDisplay = props => {
    const { onClick } = props
    const notSwipeable = _.isNil(onClick) ? false : true
    SetIsSwipeable(notSwipeable)
    return null
  }

  const benefitSettings = {
    slidesToShow: 3.3,
    speed: 500,
    infinite: false,
    slidesToScroll: 3.3,
    rows: 2,
    dots: false,
    nextArrow: <SlideDisplay />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          rows: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          rows: 2,
        },
      },
    ],
  }

  const productSettings = {
    slidesToShow: 4,
    speed: 500,
    infinite: false,
    slidesToScroll: 4,
    rows: 1,
    dots: true,
    beforeChange: (current, next) => setProductIndex(next),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  }

  const solutionSettings = {
    slidesToShow: 4,
    speed: 500,
    infinite: false,
    slidesToScroll: 4,
    rows: 1,
    dots: true,
    beforeChange: (current, next) => setSolIndex(next),
    nextArrow: <NavigateNext />,
    prevArrow: <NavigatePrevious />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  }

  return (
    <div className={classes.rootContainer}>
      <Grid container direction="column">
        <Grid item xs={12} className={classes.introHead}>
          <Typography align="center">
            We Make Your Present And Future
          </Typography>
          <Typography align="center">Stronger Than Your Past.</Typography>
        </Grid>
        <Grid item xs={12} className={classes.introImage}>
          <img
            src={upMD ? webBanner : mobBanner}
            className={classes.bannerImage}
          />
        </Grid>
        <Grid item xs={12} className={classes.scrollContainer}>
          <div className={classes.chevron}></div>
          <div className={classes.chevron}></div>
          <div className={classes.chevron}></div>
          <Typography align="center">Sroll Down</Typography>
        </Grid>
        <Grid item xs={12} className={classes.sectionHeads}>
          <Typography variant="h5" align="center">
            THE HOW & WHAT
          </Typography>
          <Typography variant="body2" align="center">
            We are a UK based company providing a simple, reliable and powerful
            solutions to brand for profitable growth.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.pinkSection}>
          <Grid container>
            <Grid item xs={12} md={5} className={classes.firstCardContainer}>
              <Card className={classes.firstCard}>
                <CardContent>
                  <Typography align="center" className={classes.firstCardTitle}>
                    HOW WE STARTED?
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    className={classes.firstCardSubTitle}
                  >
                    We started with Data Analytics Services and had catered
                    clients of various sectors.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={2} className={classes.hwImgContainer}>
              <img src={firstImgHW} className={classes.howWeStartedImage} />
            </Grid>
            <Grid item xs={12} md={5} className={classes.firstCardContainer}>
              <Card className={classes.firstCard}>
                <CardContent>
                  <Typography align="center" className={classes.firstCardTitle}>
                    BIRTH OF IDEA
                  </Typography>
                  <Typography variant="body2" align="center">
                    While serving clients, Wersel Workdesk came across many
                    common issues. They were:
                  </Typography>
                  <Typography variant="body2" align="center" component={"div"}>
                    <ul className={classes.ulList}>
                      <li>- Scattered Data</li>
                      <li>- Incomplete Data</li>
                      <li>- Poor Data Visualization</li>
                    </ul>
                    They needed a unified solution to get a 360 degree analysis
                    of everything.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.blueSection}>
          <Grid container>
            <Grid item xs={12} md={3} className={classes.hwImgContainer}>
              <img
                src={secondImgHW}
                className={classNames(
                  classes.howWeStartedImage,
                  classes.secondImgHW
                )}
              />
            </Grid>
            <Grid item xs={12} md={6} className={classes.firstCardContainer}>
              <Card className={classes.firstCard}>
                <CardContent>
                  <Typography align="center" className={classes.firstCardTitle}>
                    FINALLY WERSEL WORKDESK WAS BORN
                  </Typography>
                  <Typography
                    variant="body2"
                    align="center"
                    className={classes.firstCardSubTitle}
                  >
                    Wersel Workdesk is an AI enabled people analytics solution.
                    Giving brands intelligent 360 degree solution.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={3} className={classes.hwImgContainer}>
              <img
                src={thirdImgHW}
                className={classNames(
                  classes.howWeStartedImage,
                  classes.thirdImgHW
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.sectionHeads}>
          <Typography variant="body2" align="center">
            * Wersel domain is owned by Datinfi
          </Typography>
          <Typography variant="h5" align="center">
            BENEFITS OF WERSEL WORKDESK
          </Typography>
          <Typography variant="body2" align="center">
            What benefits do brands get from Wersel's Solutions
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.benefitsContent}>
          <Carousel {...benefitSettings}>
            {sectionData.benefits.map((txt, index) => (
              <>
                <Card className={classes.benefitsCard} key={index}>
                  <CardContent>
                    <Typography className={classes.benefitsCardTitle}>
                      {txt.title}
                    </Typography>
                    <Typography variant="body2">{txt.text}</Typography>
                  </CardContent>
                </Card>
                {txt.border && <Divider />}
              </>
            ))}
          </Carousel>
          <div
            className={classes.swipeWrapper}
            style={{ visibility: !isSwipeable && "hidden" }}
          >
            <div className={classes.arrowContainer}>
              <span>
                <span></span>
              </span>
            </div>
            <div>
              <Typography variant="body2">Swipe</Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.productSection}>
          <div
            className={classNames(classes.sectionHeads, classes.productHead)}
          >
            <Typography variant="h5" align="center">
              "Divided by Name, Implemented as One"
            </Typography>
            <Typography variant="body2" align="center">
              Success requires having the <b>right data</b> to the{" "}
              <b>right person </b>
              at the <b>right time</b>.
            </Typography>
          </div>
          <Carousel {...productSettings} className={classes.productSlider}>
            {sectionData.products.map((txt, index) => (
              <Card className={classes.productCard} key={index}>
                <CardContent>
                  <Typography variant="h5" className={classes.productCardTitle}>
                    {txt.title}
                    <div
                      style={{
                        position: "absolute",
                        width: "2.2rem",
                        bottom: 0,
                        borderBottom: `3px solid ${txt.color}`,
                      }}
                    />
                  </Typography>

                  <Typography variant="body2">{txt.text}</Typography>
                </CardContent>
              </Card>
            ))}
          </Carousel>
        </Grid>
        <Grid
          item
          xs={12}
          className={classes.solutionSection}
          style={{
            backgroundImage: upMD
              ? `url(${webSolution})`
              : `url(${mobSolution})`,
          }}
        >
          <Typography variant="body1" className={classes.solutionHead}>
            How do we make
            <br />
            you an Influential
            <br />
            Brand?
          </Typography>
          <Typography variant="subtitle1">
            Our ideology is to provide you with a solution that simplifies all
            your complexity{" "}
          </Typography>
          <img
            src={arrowDown}
            className={classes.arrowDown}
            alt="scroll-down"
          />
        </Grid>
        <Grid item xs={12} className={classes.bookingSection}>
          {sectionData.solutions.map((txt, index) => (
            <div className={classes.solutionCardHolder} key={index}>
              <div className={classes.solutionDetails}>
                <Avatar>{index + 1}</Avatar>
                <Typography variant="subtitle1">
                  {txt.text}
                  <div
                    style={{
                      position: "absolute",
                      width: "2.2rem",
                      bottom: 0,
                      borderBottom: `4px solid ${txt?.color}`,
                      borderRadius: "4px",
                    }}
                  />
                </Typography>
              </div>
            </div>
          ))}
          <Carousel {...solutionSettings} className={classes.solutionSlider}>
            {sectionData.solutions.map((txt, index) => (
              <div className={classes.solutionDetails} key={index}>
                <Avatar>{index + 1}</Avatar>
                <div className={classes.solutionCard}>
                  <Typography variant="subtitle1">{txt.text}</Typography>
                  <div
                    style={{
                      borderRight: `6px solid ${txt.color}`,
                    }}
                    className={classes.solDivider}
                  ></div>
                </div>
              </div>
            ))}
          </Carousel>

          <Divider />
          <div className={classes.demoSection}>
            <Typography variant="body1" align="center">
              Leverage your brands and take them to a completely new level
            </Typography>
            <Typography variant="subtitle1" align="center">
              Click to unlock your unseen potential
            </Typography>
            <Button variant="contained" disableElevation href="/contact" style={{ background: 'linear-gradient(108deg, #00507f 0%, #15b09a 100%)' }}>
              BOOK DEMO
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default OurStory
